import { useState } from 'react'
import axios from 'axios'
import { getToken } from 'tennders-stracture/libs/api'
import { useToast } from 'tennders-common/hooks/useToast'
import useTranslation from 'next-translate/useTranslation'

const useInputFile = (props) => {
  const {
    params,
    url,
    next
  } = props
  const { t } = useTranslation('document')
  const { toastSuccess, toastError } = useToast()
  const [submitting, setSubmitting] = useState(false)

  const submitForm = (file) => {
    const formData = new FormData()
    for (let i = 0; i < Object.keys(params).length; i++) {
      const param = Object.keys(params)[i]
      formData.append(param, params[param])
    }
    formData.append('docFile', file)
    const headers = { Authorization: `Bearer ${getToken()}` }
    setSubmitting(true)
    axios
      .post(process.env.API_URL + url, formData, { headers })
      .then((response) => {
        setSubmitting(false)
        toastSuccess(t('document_uploaded'))
        if (next) {
          next(response.data)
        }
      })
      .catch(() => {
        setSubmitting(false)
        // eslint-disable-next-line no-alert
        toastError(t('file_upload_error'))
      })
  }

  const upload = (e) => {
    e.preventDefault()
    if (e.target.files.length === 0) {
      return
    }
    const file = e.target.files[0]
    const fileSizeInMB = file?.size / (1024 * 1024)
    if (fileSizeInMB && fileSizeInMB <= 100) {
      submitForm(file)
    } else {
      toastError(t('document_size_error'))
    }
  }

  return {
    submitting,
    upload
  }
}

export default useInputFile
